import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScreenSizeService } from './utils/screenSize.service';
import { WriteReviewComponent } from '../app/web/components/write-review/write-review.component';
import { OffcanvasHistoryService } from './offcanvas-history.service';

@Injectable({
  providedIn: 'root',
})
export class OpenWriteReviewModalService {
  constructor(
    private modalService: NgbModal,
    private offcanvasHistory: OffcanvasHistoryService,
    private screenSize: ScreenSizeService
  ) { }

  async openWriteReviewModal(partner: { id: number; name: string },
    requiredComment = true, forceOffcanvas = false, enableQuestion = false): Promise<any> {
    return this.openWriteReviewModalWithCustomer(partner, undefined, requiredComment, forceOffcanvas, enableQuestion);
  }

  async openWriteReviewModalWithCustomer(partner: { id: number; name: string },
    customer?: { name: string, countryCode: string, phoneNumber: string, leadAssignmentId?: number | undefined },
    requiredComment = true, forceOffcanvas = false, isVerified = false): Promise<any> {

    if (this.screenSize.isDesktop && !forceOffcanvas) {
      const modalRef = this.modalService.open(WriteReviewComponent, {
        backdrop: true,
        centered: false,
        size: 'lg',
        scrollable: true,
      });

      modalRef.componentInstance.requiredComment = requiredComment
      modalRef.componentInstance.clinicName = partner?.name;
      modalRef.componentInstance.partnerId = partner?.id;
      modalRef.componentInstance.partnerId = partner?.id;
      modalRef.componentInstance.isVerified = isVerified;
      modalRef.componentInstance.formModel.name = customer?.name;
      modalRef.componentInstance.formModel.country = customer?.countryCode;
      modalRef.componentInstance.formModel.phoneNumber = customer?.phoneNumber;
      modalRef.componentInstance.leadAssignmentId = customer?.leadAssignmentId;

      return modalRef.result;

    } else {

      const offcanvasRef = this.offcanvasHistory.open(WriteReviewComponent, {
        panelClass: 'app-offcanvas-taller',
        position: 'bottom',
        scroll: false,
        backdrop: true,
      });

      offcanvasRef.componentInstance.requiredComment = requiredComment
      offcanvasRef.componentInstance.clinicName = partner?.name;
      offcanvasRef.componentInstance.partnerId = partner?.id;
      offcanvasRef.componentInstance.isOffcanvas = true;
      offcanvasRef.componentInstance.formModel.name = customer?.name;
      offcanvasRef.componentInstance.formModel.country = customer?.countryCode;
      offcanvasRef.componentInstance.formModel.phoneNumber = customer?.phoneNumber;
      offcanvasRef.componentInstance.isVerified = isVerified;
      offcanvasRef.componentInstance.leadAssignmentId = customer?.leadAssignmentId;
      return offcanvasRef.result;
    }
  }
}
